<app-center-dialog-layout [showCloseButton]="true" (dismissed)="dismiss()">
    <div title>Change firmware</div>

    <div class="flex min-h-[200px] flex-col gap-4">
        @if (firmwareOptions()?.length) {
            <app-select [options]="firmwareOptions()" (selectionChange)="changeFirmware($event.value)"></app-select>
        } @else {
            <div class="text-center" dcTypography="bulevar-16">No suitable firmware found</div>
        }
    </div>

    <div footer class="dialog-buttons-container">
        <button
            type="button"
            class="w-full"
            dcButton
            dcBgColor="oche-orange"
            [disabled]="!selectedFirmware()"
            (click)="patch()">
            Patch
        </button>
    </div>
</app-center-dialog-layout>
